import { memo, Children, PropsWithChildren, useState } from 'react';
import { Text, Icon } from '@betty/moonlight';

import styles from './Accordion.module.css';
import { AccordionItemProps } from './Accordion.types';

const AccordionItem = ({
  children,
  title,
  ...rest
}: PropsWithChildren<AccordionItemProps>) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div {...rest}>
      {Children.map(children, (child) => (
        <div className={`${styles.accordionItem} ${isOpen ? styles.open : ''}`}>
          <div
            className={styles.accordionTitle}
            onClick={() => setIsOpen(!isOpen)}
          >
            <Text variant="h6" color="darkSurfacePrimary" maxWidth="88%">
              {title}
            </Text>
            <div className={styles.itemArrow}>
              <Icon name="arrowForwardIosOutlined" gradient="accentBackground" width={10} height={10} />
            </div>
          </div>
          <div className={styles.accordionItemContent}>{child}</div>
        </div>
      ))}
    </div>
  );
};
export default memo(AccordionItem);
